import { render, staticRenderFns } from "./InvitationForm.vue?vue&type=template&id=9cb0ee96&"
import script from "./InvitationForm.vue?vue&type=script&lang=js&"
export * from "./InvitationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports